import { createRouter, createWebHistory } from 'vue-router'
import { applySeo } from '@/composables/seo'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      seo: {
        title: "HANDLE Marketplace",
        description: "Buy, sell, and build with confidence on the HANDLE Marketplace.",
        keywords: "healthcare equipment, medical equipment marketplace, buy equipment, sell equipment, buildouts",
      },
    },
    component: () => import( '../views/indexView.vue')
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      seo: {
        title: "About HANDLE Marketplace",
        description: "Learn how HANDLE Marketplace simplifies healthcare equipment decisions.",
        keywords: "about handle marketplace, healthcare sourcing, equipment lifecycle",
      },
    },
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/quotebuilder/',
    name: 'quote_builder',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Quote Builder',
          link: true,
          exact: true,
          disabled: true,
          href: '/quotebuilder',
        },
      ],
    },
    //route
    component: () => import('../views/quote_builder/tileView.vue')
  },
  {
    path: '/quotebuilder/tile',
    name: 'quote_builder_tile',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Quote Builder',
          link: true,
          exact: true,
          disabled: true,
          href: '/quotebuilder/tile',
        },
      ],
    },
    //route
    component: () => import('../views/quote_builder/tileView.vue')
  },
  {
    path: '/quotebuilder/products/:id/:name/:manufacturer',
    name: 'products',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Quote Builder',
          link: true,
          exact: true,
          disabled: false,
          href: '/quotebuilder/tile',
        },
        {
          title: 'Product',
          link: true,
          exact: true,
          disabled: true,
          href: '/quotebuilder/products/:id/:name/:manufacturer',
        },
      ],
    },
    //route
    component: () => import('../views/products/indexView.vue')
  },
  {
    path: '/quotebuilder/checkout',
    name: 'checkout',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Quote Builder',
          link: true,
          exact: true,
          disabled: false,
          href: '/quotebuilder/tile',
        },
        {
          title: 'Checkout',
          link: true,
          exact: true,
          disabled: true,
          href: '/quotebuilder/checkout',
        },
      ],
    },
    //route
    component: () => import('../views/quote_builder/checkoutView.vue')
  },
  {
    path: '/equipment/',
    name: 'equipment',
    meta: {
      layout: "default",
      seo: {
        title: "Buy Healthcare Equipment",
        description: "Browse healthcare equipment listings, compare options, and request quotes.",
        keywords: "buy medical equipment, healthcare equipment listings, refurbished equipment",
      },
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Equipment',
          link: true,
          exact: true,
          disabled: true,
          href: '/equipment',
        },
      ],
    },
    //route
    component: () => import('../views/equipment/indexView.vue')
  },
  {
    path: '/buildouts/',
    name: 'buildouts',
    meta: {
      layout: "default",
      seo: {
        title: "Healthcare Buildouts",
        description: "Plan and source healthcare facility buildouts with curated templates and logistics support.",
        keywords: "healthcare buildouts, ASC buildout, equipment planning",
      },
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Buildouts',
          link: true,
          exact: true,
          disabled: true,
          href: '/buildouts',
        },
      ],
    },
    //route
    component: () => import('../views/buildouts/indexView.vue')
  },
  {
    path: '/buildouts/rooms/',
    name: 'buildout_rooms',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Buildouts',
          link: true,
          exact: true,
          disabled: false,
          href: '/buildouts',
        },
        {
          title: 'Buildout Rooms',
          link: true,
          exact: true,
          disabled: true,
          href: '/buildouts/rooms',
        },
      ],
    },
    //route
    component: () => import('../views/buildouts/buildoutView.vue')
  },
  {
    path: '/buildouts/categories/:buildout_id/:name',
    name: 'buildout_categories',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Buildouts',
          link: true,
          exact: true,
          disabled: false,
          href: '/buildouts',
        },
        {
          title: 'Categories',
          link: true,
          exact: true,
          disabled: true,
          href: '/buildouts/categories',
        },
      ],
    },
    //route
    component: () => import('../views/buildouts/categoriesView.vue')
  },
  {
    path: '/dispositions',
    name: 'dispositions',
    meta: {
      layout: "default",
      seo: {
        title: "Sell Healthcare Equipment",
        description: "Submit surplus equipment for disposition and maximize asset value.",
        keywords: "sell medical equipment, equipment disposition, surplus healthcare equipment",
      },
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Dispositions',
          link: true,
          exact: true,
          disabled: true,
          href: '/dispositions',
        },
      ],
    },
    //route
    component: () => import('../views/dispositions/indexView.vue')
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Account',
          link: true,
          exact: true,
          disabled: true,
          href: '/account',
        },
      ],
    },
    //route
    component: () => import('../views/account/indexView.vue')
  },
  {
    path: '/account/settings',
    name: 'account_settings',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Account',
          link: true,
          exact: true,
          disabled: false,
          href: '/account',
        },
        {
          title: 'Settings',
          link: true,
          exact: true,
          disabled: true,
          href: '/account/settings',
        },
      ],
    },
    //route
    component: () => import('../views/account/userView.vue')
  },
  {
    path: '/account/dispositions',
    name: 'account_dispositions',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Account',
          link: true,
          exact: true,
          disabled: false,
          href: '/account',
        },
        {
          title: 'Dispositions',
          link: true,
          exact: true,
          disabled: true,
          href: '/account/dispositions',
        },
      ],
    },
    //route
    component: () => import('../views/account/dispositionView.vue')
  },
  {
    path: '/account/orders',
    name: 'account_orders',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Account',
          link: true,
          exact: true,
          disabled: false,
          href: '/account',
        },
        {
          title: 'Orders',
          link: true,
          exact: true,
          disabled: true,
          href: '/account/orders',
        },
      ],
    },
    //route
    component: () => import('../views/account/orderView.vue')
  },
  {
    path: '/account/quotes',
    name: 'account_quotes',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Account',
          link: true,
          exact: true,
          disabled: false,
          href: '/account',
        },
        {
          title: 'Quotes',
          link: true,
          exact: true,
          disabled: true,
          href: '/account/quotes',
        },
      ],
    },
    //route
    component: () => import('../views/account/quoteView.vue')
  },
  {
    path: '/account/notifications',
    name: 'notifications',
    meta: {
      layout: "default",
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Account',
          link: true,
          exact: true,
          disabled: false,
          href: '/account',
        },
        {
          title: 'Notifications',
          link: true,
          exact: true,
          disabled: false,
          href: '/notifications',
        },
      ],
    },
    component: () => import('../views/account/notificationsView.vue')
  },
  {
    path: '/contact/',
    name: 'contact',
    meta: {
      layout: "default",
      seo: {
        title: "Contact HANDLE Marketplace",
        description: "Contact HANDLE Marketplace for product sourcing, disposition, and buildout support.",
        keywords: "contact handle marketplace, healthcare equipment support",
      },
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Contact',
          link: true,
          exact: true,
          disabled: true,
          href: '/contact',
        },
      ],
    },
    //route
    component: () => import('../views/contact/indexView.vue')
  },
  {
    path: '/schedule/',
    name: 'schedule',
    meta: {
      layout: "default",
      seo: {
        title: "Schedule a Planning Call",
        description: "Schedule a call with HANDLE Marketplace to discuss your equipment needs.",
        keywords: "schedule consultation, equipment planning call",
      },
      breadcrumbs: [
        {
          title: 'Home',
          link: true,
          exact: true,
          disabled: false,
          href: '/',
        },
        {
          title: 'Schedule',
          link: true,
          exact: true,
          disabled: true,
          href: '/schedule',
        },
      ],
    },
    //route
    component: () => import('../views/schedule/indexView.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    meta: {
      layout: "public",
      seo: {
        title: "Sign Up | HANDLE Marketplace",
        description: "Create your HANDLE Marketplace account to manage quotes and requests.",
        keywords: "handle marketplace signup, create marketplace account",
      },
    },
    //route
    component: () => import('../views/login/signupView.vue')
  },
  {
    path: '/verify/:token',
    name: 'verify',
    meta: { layout: "public"},
    //route
    component: () => import('../views/login/verifyView.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: "public",
      seo: {
        title: "Login | HANDLE Marketplace",
        description: "Login to HANDLE Marketplace to manage account, quotes, and orders.",
        keywords: "handle marketplace login, customer portal",
      },
    },
    //route
    component: () => import('../views/login/loginView.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    meta: { layout: "public"},
    //route
    component: () => import('../views/login/logoutView.vue')
  },
  {
    path: '/password/request',
    name: 'password_request',
    meta: {
      layout: "public",
      seo: {
        title: "Password Reset Request",
        description: "Request a password reset email for your HANDLE Marketplace account.",
        keywords: "password reset request, handle marketplace account recovery",
      },
    },
    //route
    component: () => import('../views/login/password_requestView.vue')
  },
  {
    path: '/password/reset/:token',
    name: 'password_reset',
    meta: {
      layout: "public",
      seo: {
        title: "Reset Password",
        description: "Set a new password for your HANDLE Marketplace account.",
        keywords: "reset password, account recovery",
      },
    },
    //route
    component: () => import('../views/login/password_resetView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  if (to?.meta?.seo) {
    const globalKeywords = localStorage.getItem("keywords");
    applySeo({
      ...to.meta.seo,
      keywords: [globalKeywords, to.meta.seo.keywords],
      url: window.location.href,
    });
  }
});

export default router
